import { container } from '@shared/common/dependency-injection/domain/container.ts';
import type { RouteLocationRaw } from 'vue-router';
import { CustomerChatbotDependencyTypes } from '@client/feature/customer-chatbots/customer-chatbot.dependency-types.ts';
import type { CustomerChatbotService } from '@client/feature/customer-chatbots/domain/service/customer-chatbot.service.ts';
import type { ErrorMonitoringService } from '@kiplin/web-common/error-monitoring';
import { ErrorMonitoringDependencyTypes } from '@shared/common/error-monitoring/error-monitoring.dependency-types';

async function initAndRefreshChatbot(identifyChatbotVisitorWithAuthenticatedUser: boolean) {
  const customerChatbotService = container.get<CustomerChatbotService>(
    CustomerChatbotDependencyTypes.CustomerChatbotService,
  );
  await customerChatbotService.initialize({
    identifyChatbotVisitorWithAuthenticatedUser: identifyChatbotVisitorWithAuthenticatedUser,
  });
  await customerChatbotService.refresh();
}

let latestCustomerChatbotInitialisationFlow = Promise.resolve();

export async function checkCustomerChatbotInitialized(options: {
  identifyChatbotVisitorWithAuthenticatedUser: boolean;
}): Promise<boolean | RouteLocationRaw> {
  // no await used here to not block the page navigation
  latestCustomerChatbotInitialisationFlow = latestCustomerChatbotInitialisationFlow
    .catch(() => undefined)
    .then(() => initAndRefreshChatbot(options.identifyChatbotVisitorWithAuthenticatedUser))
    .catch((error: unknown) => {
      const errorMonitoringService = container.get<ErrorMonitoringService>(
        ErrorMonitoringDependencyTypes.ErrorMonitoringService,
      );
      errorMonitoringService.captureException(error);
    });

  return true;
}
